<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FileDisaplayLocals',
})
</script>
<template>
  <Row :gutter="[16, 16]" v-if="files.length">
    <Col v-for="item in files" :key="item.id" v-bind="colAttrs">
      <FileDisplayLocal :record="item" v-bind="$attrs" :closeable="closeable" @del="() => $emit('del', item.id!)" />
    </Col>
  </Row>
</template>

<script lang="ts" setup name="FileDisaplayLocals">
import { Col, Row } from 'ant-design-vue'
import { fileDisplayLocalsProps } from './props'
import FileDisplayLocal from './Local.vue'

defineProps(fileDisplayLocalsProps)
defineEmits<{
  (e: 'del', id: string): void
}>()
</script>
